import { Guests } from '@entities/leadCollector';

export enum LEAD_COLLECTOR_STEPS {
  WELCOME,
  CHOOSE_FORM,
  CREATE_FORM,
  CONSTRUCTOR_FORM,
  CREATE_LINKS,
}

export enum VIEW_TYPE {
  CONSTRUCTOR,
  PREVIEW_CONSTRUCTOR,
  PREVIEW_TEMPLATE,
}

export enum ElementTypeEnum {
  LOGO = 'LOGO',
  IMAGE = 'IMAGE',
  TITLE = 'TITLE',
  TEXT = 'TEXT',
  FORMS = 'FORMS',
  CHECKBOX = 'CHECKBOX',
  RADIOBUTTON = 'RADIOBUTTON',
  BUTTON = 'BUTTON',
}

export enum StylesText {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  LINK = 'link',
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  JUSTIFY = 'justify',
}

export const groupPlaceholder = 'Введите название группы';
export const buttonPlaceholder = 'Укажите название кнопки';

export const SUPPORTS_TYPES_FILE = ['image/jpeg', 'image/png', 'image/jpg'];
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const LOGO_TYPE_SMINEX = 1;
export const LOGO_TYPE_SMINEX_CLUB = 2;
export const IMAGE_16X9 = 3;
export const TITLE_1 = 4;
export const TITLE_2 = 5;
export const TEXT = 6;
export const CHECKBOX = 8;
export const RADIO = 9;
export const BUTTON = 10;
export const LOGO_TYPE_SMINEX_PERFECTIONISTS = 11;

export const COMPONENT_TYPE_LOGO = 'LOGO';
export const COMPONENT_TYPE_IMAGE = 'IMAGE';
export const COMPONENT_TYPE_GUEST = 'GUEST';
export const COMPONENT_TYPE_ADULT_GUEST = 'ADULTGUEST';
export const COMPONENT_TYPE_CHILD_GUEST = 'CHILDGUEST';
export const COMPONENT_TYPE_TITLE = 'TITLE';
export const COMPONENT_TYPE_TEXT = 'TEXT';
export const COMPONENT_TYPE_CHECKBOX = 'CHECKBOX';
export const COMPONENT_TYPE_RADIOBUTTON = 'RADIOBUTTON';
export const COMPONENT_TYPE_BUTTON = 'BUTTON';

export const DRAG_OPACITY_DURING_DRAG = 0.5;
export const DRAG_OPACITY_DEFAULT = 1;

export const FIELD_ID_LASTNAME = 'lastName';
export const FIELD_ID_FIRSTNAME = 'firstName';
export const FIELD_ID_SURNAME = 'surname';
export const FIELD_ID_AGE = 'age';
export const FIELD_ID_EMAIL = 'email';
export const FIELD_ID_PHONE = 'phone';
export const FIELD_ID_CUSTOM = 'custom';

export const ADULT_GUEST_BLOCK_NAME = 'Взрослый гость';
export const CHILD_GUEST_BLOCK_NAME = 'Маленький гость';

export enum FormStatusEnum {
  EXPIRED = 'EXPIRED',
  USED = 'USED',
  ACTIVE = 'ACTIVE',
}

export const DEFAULT_GUESTS: Guests = {
  mainGuest: {
    FIO: [
      { instanceId: FIELD_ID_LASTNAME, dbField: FIELD_ID_LASTNAME, placeholder: 'Фамилия', value: '', label: '' },
      { instanceId: FIELD_ID_FIRSTNAME, dbField: FIELD_ID_FIRSTNAME, placeholder: 'Имя', value: '', label: '' },
      { instanceId: FIELD_ID_SURNAME, dbField: FIELD_ID_SURNAME, placeholder: 'Отчество', value: '', label: '' },
    ],
    additionalFields: [
      {
        instanceId: FIELD_ID_PHONE,
        dbField: FIELD_ID_PHONE,
        placeholder: '+ 7 (xxx) xxx-xxxx',
        value: '',
        label: 'Ваш телефон для связи *',
      },
      {
        instanceId: FIELD_ID_EMAIL,
        dbField: FIELD_ID_EMAIL,
        placeholder: '',
        value: '',
        label: 'Ваш e-mail *',
      },
    ],
  },
  adultGuest: [
    {
      FIO: [
        { instanceId: FIELD_ID_LASTNAME, dbField: FIELD_ID_LASTNAME, placeholder: 'Фамилия', value: '', label: '' },
        { instanceId: FIELD_ID_FIRSTNAME, dbField: FIELD_ID_FIRSTNAME, placeholder: 'Имя', value: '', label: '' },
        { instanceId: FIELD_ID_SURNAME, dbField: FIELD_ID_SURNAME, placeholder: 'Отчество', value: '', label: '' },
      ],
      additionalFields: [],
    },
  ],
  childrenGuest: [
    {
      FIO: [
        { instanceId: FIELD_ID_FIRSTNAME, dbField: FIELD_ID_FIRSTNAME, placeholder: 'Имя', value: '', label: '' },
        { instanceId: FIELD_ID_AGE, dbField: FIELD_ID_AGE, placeholder: 'Возраст', value: '', label: '' },
      ],
      additionalFields: [],
    },
  ],
};
